import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-309916a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["readonly"]

import { onMounted, ref, watch } from "vue";
import { useContentStore } from "@/stores/content.store";
import { useUIContentStore } from "@/stores/ui-content.store";
import { showToast } from "@/services/notification-manager";
import { SECTION } from "@/constants/assets.constant";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentName',
  props: {
  contentName: {
    required: true,
    type: String
  },
  sectionId: {
    required: true,
    type: Number
  },
  productId: {
    required: true,
    type: Number
  },
  canEditContent: {
    required: true,
    type: Boolean
  }
},
  setup(__props) {

const contentStore = useContentStore();
const uiContentStore = useUIContentStore();

const props = __props;

const name = ref<string>("");
onMounted(() => {
  name.value = props.contentName;
});
watch(
  () => props.contentName,
  newVal => {
    if (newVal) {
      name.value = newVal;
    }
  }
);
const saveContentName = (): void => {
  if (name.value !== "" && name.value !== props.contentName) {
    contentStore
      .upsertSections({
        productIds: [props.productId],
        sections: [
          {
            id: props.sectionId,
            name: name.value
          }
        ]
      })
      .catch(error => {
        showToast({
          message: `${SECTION.ERRORS.nameNotUpdated}: ${error.message}`,
          type: "is-danger"
        });
      });
  }
};

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    id: "content-name",
    "data-testing": "edit-section-name",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
    class: _normalizeClass([
      'ghost-input',
      { expanded: _unref(uiContentStore).isContentSidebarExpanded }
    ]),
    readonly: !__props.canEditContent,
    onChange: saveContentName
  }, null, 42, _hoisted_1)), [
    [
      _vModelText,
      name.value,
      void 0,
      { trim: true }
    ]
  ])
}
}

})